"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeZoneName = getTimeZoneName;
const timezone_soft_1 = __importDefault(require("timezone-soft"));
function getTimeZoneName(m) {
    const iana = m.tz();
    if (iana !== undefined) {
        const info = (0, timezone_soft_1.default)(iana);
        if (info.length > 0) {
            if (info[0].daylight !== null && m.isDST()) {
                return info[0].daylight.name;
            }
            else {
                return info[0].standard.name;
            }
        }
    }
    return m.format("zz"); // fall back on moment's output
}
